import * as yup from 'yup';

export const FIELD_ORGANIZATION = 'organization';
export const FIELD_DATE = 'date';
export const FIELD_TIME = 'time';

export const AttestationsEditValidationForm = yup.object().shape({
  [FIELD_ORGANIZATION]: yup.string().required('error.required').trim(),
  [FIELD_DATE]: yup.date().required('error.required'),
  [FIELD_TIME]: yup.string().required('error.required').trim(),
});
